<template>
  <div class="price-container">
    <div class="price-header">
      <div class="title title-price small uppercase">
        <b>{{ $t("Price") }}</b>
      </div>
    </div>
    <div class="inputs">
      <div class="desc curr">{{ currencySymbol }}</div>
      <img
        src="./../assets/img/arrow-right-new.svg"
        alt="arrow"
        class="arrow"
      />
      <div class="desc curr">{{ currencySymbol }}</div>
      <input
        v-model="minValueInput"
        type="text"
        @input="filterNumericInput($event, 'minValueInput')"
        @blur="handleMinBlur"
        pattern="[0-9.]*"
        inputmode="decimal"
      />
      <input
        v-model="maxValueInput"
        type="text"
        @input="filterNumericInput($event, 'maxValueInput')"
        @blur="handleMaxBlur"
        pattern="[0-9.]*"
        inputmode="decimal"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    minValue: { type: Number, required: true },
    maxValue: { type: [Number, null], required: true },
    maxBarValue: { type: Number, required: true },
  },
  emits: ["update-range"],
  data() {
    return {
      minValueInput: String(this.minValue),
      maxValueInput: this.maxValue === null ? "" : String(this.maxValue),
    };
  },
  computed: {
    ...mapGetters("app", ["currencySymbol"]),
  },
  watch: {
    minValue(newValue) {
      this.minValueInput = String(newValue);
    },
    maxValue(newValue) {
      this.maxValueInput = newValue === null ? "" : String(newValue);
    },
  },
  methods: {
    handleMinBlur() {
      let parsedMin = this.safeParseNumber(
        this.minValueInput,
        0,
        this.maxBarValue,
      );
      const currentMax =
        this.maxValue === null ? this.maxBarValue : this.maxValue;

      if (parsedMin > currentMax) {
        parsedMin = currentMax;
      }

      this.minValueInput = parsedMin.toFixed(2);

      this.$emit("update-range", {
        min: parsedMin,
        max: this.maxValue,
      });
    },
    handleMaxBlur() {
      if (this.maxValueInput.trim() === "") {
        this.$emit("update-range", {
          min: this.minValue,
          max: null,
        });
        return;
      }

      let parsedMax = this.safeParseNumber(
        this.maxValueInput,
        0,
        this.maxBarValue,
      );

      if (parsedMax < this.minValue) {
        parsedMax = this.minValue;
      }

      this.maxValueInput = parsedMax.toFixed(2);

      this.$emit("update-range", {
        min: this.minValue,
        max: parsedMax,
      });
    },
    safeParseNumber(value, min, max) {
      if (value === null || String(value).trim() === "") return min;
      const num = parseFloat(String(value).replace(/[^0-9.]/g, ""));
      if (isNaN(num)) return min;
      return Math.max(min, Math.min(max, num));
    },
    filterNumericInput(event, field) {
      let value = event.target.value;
      const parts = value.split(".");
      if (parts.length > 2) {
        value = this[field]; // Revert on second dot
      } else if (parts.length === 2 && parts[1].length > 2) {
        value = this[field]; // Revert on third decimal
      } else if (/[^0-9.]/.test(value)) {
        value = this[field]; // Revert on non-numeric
      }
      this[field] = value;
    },
  },
};
</script>

<style lang="scss" scoped>
/* твои стили без изменений */
.price-container {
  display: flex;
  flex-direction: column;
  gap: 18px;

  .inputs {
    display: flex;
    justify-content: space-between;
    column-gap: 42px;
    position: relative;
    max-width: 242px;

    .arrow {
      position: absolute;
      left: 112px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
    }

    .curr {
      color: #d2d2e6;
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
    }

    .arrow + .curr {
      left: 150px;
    }

    input {
      padding-left: 20px;
    }
  }

  .title-price {
    font-size: 14px;
    line-height: 18px;
  }
}

.price-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.from-value,
.to-value {
  display: flex;
  align-items: center;

  gap: 6px;
}

.price-range {
  display: flex;
  align-items: center;
  gap: 12px;

  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.06px;
  text-align: left;
  color: white;
}

.from,
.to {
  color: #686a7f;
}

.min-value,
.max-value {
  height: 14px;
}

.slider-wrapper {
  position: relative;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;

  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 14.06px;
  text-align: left;
  color: white;
}
</style>
